// import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import emailjs from "@emailjs/browser";
import './App.css';
import Navbar from "./components/Navbar.tsx"
import Landing from "./pages/Landing.tsx"
import Products from "./pages/Products.tsx"
import Booking from "./pages/Booking.tsx"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

function App() {
  if (publicKey) {
    emailjs.init(publicKey);
  } else {
    console.error("FATAL ERROR: EmailJS Public Key is missing. Check your .env file and ensure it starts with REACT_APP_");
  }

  return (
    <Router>
      <Navbar logoText="Velvet Hour" />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/products" element={<Products />} />
        <Route path="/booking" element={<Booking />} />
      </Routes>
    </Router>
  );
}

export default App;
